// eslint-disable-next-line import/prefer-default-export
export const ReservationType = {
  Event: 1,
  Interview: 2,
};
